import moment from 'moment';
import { DATE_TIME_FORMAT } from '@/config';
import { renderIntlLabel } from '@/utils';
import { parseFen2Currency, parseFen2Yuan } from '@/utils/number';
import { getTimeByUtcOffset, TenantSignStorage } from '@/utils/intl';

export const getPrintCss = () => {
  const cssStyleSheetStr = `
  <style rel="stylesheet">
    body{
      margin: 0;
    }
    @page {
      size: auto;
      margin: 16px 0px;
    }
    .billContent {
      display: inline-block;
      padding: 0 0px 10px;
      margin: 0 auto;
      background-color: #f8f8fa;
      width: 378px;
      font-family: "黑体", "微软雅黑", "宋体";
    }

    .billContentBg {
      width: 398px;
      height: 258px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0px;
      border: none;
    }

    .billContentBg > img{
      width: 100%;
      display: block;
    }

    .contentBox {
      position: relative;
      z-index: 2;
    }

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
      color: #000;
      padding: 0px 0 24px;
    }

    .title > img {
      margin-right: 6px;
        width: 32px;
    }

    .subject {
      margin: 7px 0 24px;
      font-size: 24px;
      font-weight: 600;
      color: #000;
      line-height: 33px;
      text-align: center;
    }

    .orderDetail {
      padding: 0 14px;
      background-color: #fff;
      border-radius: 8px;
      margin-bottom: 10px;
    }

    .orderDetail > .name {
      padding: 19px 0 20px;
      text-align: center;
      font-size: 20px;
      color: #000;
      line-height: 28px;
      font-weight: bold;
    }

    .orderDetail > .itemTitle {
      border-bottom: 1px solid #000;
      font-weight: bold;
      font-size: 16px;
      color: #000;
      line-height: 22px;
      padding: 14px 0;
      text-align: left;
    }

    .orderDetailItem {
      display: flex;
      justify-content: space-between;
      padding: 14px 0;
      border-bottom: 1px solid #000;
    }


    .orderDetailItem:last-child {
      // border: none;
    }

    .orderDetailItem .detailLabel {
      font-size: 14px;
      color: #000;
      line-height: 20px;
    }


    .orderDetailItem .detailContent {
      font-weight: 500;
      font-size: 14px;
      color: #000;
      line-height: 20px;
      text-align: right;
      max-width: 240px;
    }

    .orderDetailItemFirst{
      align-items: flex-start;
    }

    .orderDetailItemFirst .detailLabel{
      font-size: 14px;
      color: #000;
      line-height: 20px;
      font-weight: bold;
    }

    .orderDetailItemFirst .detailContent{
      font-weight: bold;
      font-size: 28px;
      color: #000;
    }

    .orderDetailItemFirst .detailContent .points {
      margin-top: 6px;
      font-size: 12px;
      color: #000;
      line-height: 18px;
    }

    .codeScan {
      background-color: #fff;
      border-radius: 8px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 18px;
    }

    .codeScan > .pointing {
      font-weight: bold;
      font-size: 14px;
      color: #000;
      line-height: 17px;
      padding: 23px 0 14px;
    }

    .codeScan > .code {
      display: inline-block;
      width: 155px;
      height: 155px;
      margin: 0 auto;
    }
    .codeScan > .code  img{
      display: block;
      width: 155px;
      height: 155px;
      margin: 0 auto;
    }

    .codeScan > .prompt {
      margin-top: 14px;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: #000;
      line-height: 14px;
    }
    .codeScan > .promptTip {
      font-weight: 400;
      font-size: 12px;
      color: #000;
      line-height: 14px;
      margin-top: 6px;
      text-align: center;
    }

    .slogan {
      width: 188px;
      display: block;
      margin: 0 auto 8px;
      padding-top: 20px;
    }

    .hotline {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }

    .serviceHotline {
      justify-content: flex-end;
      margin-right: 9px;
    }
    .leagueHotline {
      margin-left: 9px;
    }
    .serviceHotline, .leagueHotline {
      display: flex;
      min-width: 180px;
      font-size: 12px;
      font-weight: bold;
      color: #000;
    }
    .serviceHotline span, .leagueHotline span {
      margin-left: 8px;
      font-weight: 400;
    }
  </style>
  `;
  return cssStyleSheetStr;
};

export const getPrintHtml = (detail) => {
  // 商户名称
  const merchantName = TenantSignStorage.getLocalConfig()?.marchantName || '--';
  const joinTel = TenantSignStorage.getLocalConfig()?.joinTel || '--';
  const serviceTel = TenantSignStorage.getLocalConfig()?.serviceTel || '--';
  const logo = TenantSignStorage.getLocalConfig()?.icon1x;
  const container = `
      <div class="billContent">
        <div class="contentBox">
          <div class="title">
            <img src="data:image/png;base64,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" alt="logo" crossOrigin="anonymous" />
            <div>${renderIntlLabel('order_crs_title_hotel_book', { merchantName })}</div>
          </div>

          <div class="orderDetail">
            <div class="name">${detail?.name}</div>
            <div class="orderDetailItem orderDetailItemFirst">
              <div class="detailLabel">${renderIntlLabel(
                'order_crs_label_actually_room_expense',
              )}</div>
              <div class="detailContent">¥${parseFen2Yuan(
                detail?.orderRealPayAmount,
              )}<div class="points">${
    detail?.pointsDeductionAmount || detail?.pointsDeductionAmount
      ? `${renderIntlLabel('channel_hotel_has_used_amount_of_points', {
          availablePoints: detail?.availablePoints,
        })}${renderIntlLabel('channel_hotel_pointsDeductionAmount', {
          money: `¥${parseFen2Yuan(detail?.pointsDeductionAmount)}`,
        })}`
      : ''
  }</div></div>
            </div>
            <div class="orderDetailItem">
              <div class="detailLabel">${renderIntlLabel('order_roomorder_subscriber')}</div>
              <div class="detailContent">${detail?.userName}</div>
            </div>
            <div class="orderDetailItem">
              <div class="detailLabel">${renderIntlLabel('order_roomorder_mobile')}</div>
              <div class="detailContent">${detail?.userPhone}</div>
            </div>
          </div>

          <div class="codeScan">
            <div class="pointing">
              ${renderIntlLabel('order_crs_tip_scan_by_wechat')}
              <br />
              ${renderIntlLabel('order_crs_tip_scan_to_confirm_to_pay')}
            </div>
            <div class="code" ref={scanCodeRef}>
              <img src="${detail?.qrcodeSrc}" alt="付款单二维码"/>
            </div>

            <div class="prompt">${renderIntlLabel('order_crs_tip_contact_theFrontDesk')}</div>
            <div class="promptTip">
              ${renderIntlLabel('order_crs_tip_search_miniProgram_by_wechat')}
              <br />
              ${renderIntlLabel('order_crs_tip_download_app')}
            </div>
          </div>

          <div class="orderDetail">
            <div class="itemTitle">${renderIntlLabel('order_goods_label_order_info')}</div>

            <div class="orderDetailItem">
              <div class="detailLabel">${renderIntlLabel('order_crs_label_store_address')}</div>
              <div class="detailContent">${detail?.address}</div>
            </div>
            <div class="orderDetailItem">
              <div class="detailLabel">${renderIntlLabel('order_crs_label_store_mobile')}</div>
              <div class="detailContent">${detail?.storePhone}</div>
            </div>
            <div class="orderDetailItem">
              <div class="detailLabel">${renderIntlLabel('order_selfService_order_no')}</div>
              <div class="detailContent">${detail?.orderNo}</div>
            </div>
            <div class="orderDetailItem">
              <div class="detailLabel">${renderIntlLabel('order_crs_label_print_order_time')}</div>
              <div class="detailContent">
                ${
                  detail?.operateTime
                    ? getTimeByUtcOffset(detail?.operateTime, DATE_TIME_FORMAT)
                    : ''
                }
              </div>
            </div>
            <div class="orderDetailItem">
              <div class="detailLabel">${renderIntlLabel('order_crs_label_print_person')}</div>
              <div class="detailContent">${detail?.operator}</div>
            </div>
          </div>

          <div>
            <img class="slogan" src="data:image/png;base64,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" alt="" />
            <div class="hotline">
              <div class="serviceHotline">
                ${renderIntlLabel('order_crs_label_wy_service_hot_line')}<span>${serviceTel}</span>
              </div>
              <div class="leagueHotline">
                ${renderIntlLabel('order_crs_label_wy_join_hot_line')}<span>${joinTel}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  `;
  return container;
};
